import SideColumnLayout from "./sideColumnLayout"

export default SideColumnLayout
